import HttpService from './HttpService';
import { pathMatterCostCodeBudgets } from '../../__settings__/septSoftwarePaths';

/** One cost code's budget and the server-computed group total (all users, all time). */
export interface CostCodeBudget {
  cost_code: string;
  budget_hours: number;
  group_hours: number;
}

interface CostCodeBudgetsGetResponse {
  successful: boolean;
  data: CostCodeBudget[];
  sept_tenantid: string;
}

/** code -> { budget, group } map, the shape the timesheet grids consume. */
export type CostCodeBudgetMap = Record<string, { budget: number; group: number }>;

const http = new HttpService();

class MatterCostCodeBudgetService {
  /**
   * Load a matter's per-code budgets + group totals as a code->{budget,group} map.
   * group_hours is server-computed over the WHOLE crew's rows (review H1) — never derive it
   * from the caller-scoped grid data. Returns {} for a matter with no budgets or hours.
   */
  static async getBudgets(matterId: string): Promise<CostCodeBudgetMap> {
    const response = await http.get<CostCodeBudgetsGetResponse>(pathMatterCostCodeBudgets(matterId));
    const map: CostCodeBudgetMap = {};
    for (const row of response.data || []) {
      map[String(row.cost_code)] = {
        budget: Number(row.budget_hours) || 0,
        group: Number(row.group_hours) || 0,
      };
    }
    return map;
  }

  /** Upsert per-code budgets (admin only; a non-admin caller gets a 403 from the API). */
  static async saveBudgets(
    matterId: string,
    rows: Array<{ cost_code: string; budget_hours: number }>,
  ): Promise<void> {
    await http.put(pathMatterCostCodeBudgets(matterId), { budgets: rows });
  }
}

export default MatterCostCodeBudgetService;
